<template>
	<Layout :navFixed="true" :transparent="true">
		<div class="container" v-if="!loading">
			<div class="row row-xs  mt-5 pb-5">
				<div class="col-12  mt-4 mb-5 justify-content-center">
					<div class="form-box card" v-if="!waitingCode">
						<div class="card-body">
							<h3 class="mt-3">{{ $t("title") }}</h3>
							<p class="mt-2">{{ $t("confirmPhoneNumber") }}</p>
							<div class="col-12 mb-3">
								<FormulateForm name="form" v-model="user" @submit="verifyPhoneRequest">
									<FormulateInput
										label="Teléfono"
										type="phone"
										name="phone"
										validation-name="Teléfono"
										validation="required|^phone"
									/>
								</FormulateForm>
							</div>
							<div class="d-flex justify-content-end mt-4">
								<div class="btn btn-primary" @click="$formulate.submit('form')">
									<span v-if="saving">{{ $t("saving") }} <span class="btn-loader" /> </span>
									<span v-else>{{ $t("button") }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-box card" v-if="waitingCode">
						<div class="card-body">
							<h3 class="mt-3">{{ $t("title") }}</h3>
							<p class="mt-2">{{ $t("setValidationCode") }}</p>

							<div class="mb-5 mt-5">
								<CodeInput
									:loading="saving"
									class="m-auto"
									v-on:change="onChange"
									v-on:complete="onComplete"
									:fieldWidth="40"
									:fieldHeight="40"
								/>
							</div>
							<div class="btn btn-link m-auto" @click="waitingCode = false">
								{{ $t("resendCode") }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import mixins from "@/mixins/mixins"
import CodeInput from "vue-verification-code-input"

export default {
	name: "PhoneValidation",
	mixins: [mixins],
	components: {
		Layout,
		CodeInput
	},
	data() {
		return {
			loading: false,
			saving: false,
			user: null,
			waitingCode: false
		}
	},
	async beforeMount() {
		this.loading = true
		await this.load()
		this.loading = false
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query {
							userLogged {
								id
								name
								lastname
								phone {
									countryCode
									national
									international
									type
									validated
								}
								phoneValidated
							}
						}
					`,
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.user = this.$omitDeep(data.userLogged, "__typename")
				})
				.catch((err) => {
					this.$toast.error("Error al cargar los dato de usuario")
				})
		},
		verifyPhoneRequest() {
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($phone: PhoneInput!) {
							userVerifyPhoneRequest(phone: $phone)
						}
					`,
					variables: {
						phone: this.user.phone
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.saving = false
					this.waitingCode = true
				})
				.catch((err) => {
					this.saving = false
					this.$toast.error("Error al enviar el sms de verificación")
				})
		},
		onChange(v) {
			this.saving = false
		},
		onComplete(v) {
			this.saving = true
			this.verifyPhone(v)
		},
		verifyPhone(code) {
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($code: String!) {
							userVerifyPhoneConfirm(code: $code)
						}
					`,
					variables: {
						code
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					if (data.userVerifyPhoneConfirm) {
						this.$toast.success("Su teléfono ha sido verificado correctamente!")
						this.$router.push("/account/security")
					}
				})
				.catch((err) => {
					this.saving = false
					this.$toast.error("Error al enviar el sms de verificación")
				})
		}
	},
	i18n: {
		messages: {
			es: {
				title: "Verificar teléfono",
				confirmPhoneNumber:
					"Verificá tu número de teléfono para que podamos enviarte información importante sobre los eventos y compras realizadas.",
				text: "Te hemos enviado un código de verificación de 6 digitos por SMS al teléfono.",
				saving: "Enviando SMS...",
				button: "Verificar número",
				setValidationCode:
					"Te hemos enviado un código de verificación de 6 digitos por SMS, ingresalo aquí para confirmar tu número.",
				resendCode: "Reenviar código"
			},
			en: {
				title: "Verify phone number",
				confirmPhoneNumber:
					"Verify your phone number to receive important information about events and purchases.",
				text: "We have sent a verification code to your phone.",
				saving: "Sending SMS...",
				button: "Verify number",
				setValidationCode:
					"We have sent a verification code to your phone, enter it here to confirm your phone number.",
				resendCode: "Resend code"
			},
			pt: {
				title: "Verificar número de telefone",
				confirmPhoneNumber:
					"Verifique seu número de telefone para receber informações importantes sobre eventos e compras.",
				text: "Enviamos um código de verificação para seu telefone.",
				saving: "Enviando SMS...",
				button: "Verificar número",
				setValidationCode:
					"Enviamos um código de verificação para seu telefone, insira-o aqui para confirmar seu número.",
				resendCode: "Reenviar código"
			}
		}
	}
}
</script>

<style scoped lang="scss">
.row {
	margin: auto;
	max-width: 460px;
}

* /deep/ .react-code-input {
	display: flex;
	gap: 8px;
	justify-content: space-around;

	input {
		border-radius: 0 !important;
		border: none !important;
		border-bottom: 2px solid #ccc !important;
		font-family: inherit;
		font-weight: 500;
	}
}
</style>
